// src/pages/bloomterminal/components/DataReportsDialog.jsx
import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import CommoditySelector from '../alerts/steps/CommoditySelector';

const DataReportsDialog = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const [selectedCommodity, setSelectedCommodity] = useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedCommodity) {
      onConfirm(selectedCommodity);
      setSelectedCommodity(null);
    }
  };

  const handleClose = () => {
    setSelectedCommodity(null);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50">
      <div className="bg-[#1d1d1d] border border-bloom-green/30 rounded-lg shadow-xl w-full max-w-[500px] mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-bloom-green/20">
          <h2 className="font-['Inter'] font-medium text-[18px] text-[#f0f5f2]">
            Generate Data Report
          </h2>
          <button 
            onClick={handleClose}
            disabled={isLoading}
            className="text-[#828382] hover:text-[#f0f5f2] transition-colors disabled:opacity-50"
          >
            <X size={20} />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <p className="font-['Inter'] text-[14px] text-[#828382] mb-4">
            Select a commodity to generate a comprehensive market trends report.
          </p>
          
          <CommoditySelector
            selectedCommodity={selectedCommodity}
            onCommodityToggle={setSelectedCommodity}
          />
        </div>
        
        {/* Footer */}
        <div className="flex justify-end gap-3 p-4 border-t border-bloom-green/20">
          <button 
            onClick={handleClose}
            disabled={isLoading}
            className="px-4 py-2 bg-[#282a29] text-[#f0f5f2] rounded-[8px] font-['Inter'] text-[14px] hover:bg-[#3a3c3b] transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button 
            onClick={handleConfirm}
            disabled={!selectedCommodity || isLoading}
            className="px-4 py-2 bg-bloom-green text-[#f0f5f2] rounded-[8px] font-['Inter'] text-[14px] font-medium hover:bg-bloom-green-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isLoading && <Loader2 size={16} className="animate-spin" />}
            {isLoading ? 'Generating...' : 'Generate Report'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataReportsDialog;

